import { Directive, HostListener, ElementRef } from '@angular/core';
@Directive({
    selector: '[wheel]',
    standalone: false
})
export class WheelDirective {

  constructor(
    private el: ElementRef
  ) { }

  @HostListener('mousewheel', ['$event']) onMousewheel(event) {

    let popupElements = document.querySelectorAll(".dx-dropdowneditor-active, .dx-popup-wrapper");
    if (popupElements.length > 0) {
      let hasTableBorderedClass: boolean = false;
      popupElements.forEach((el) => {
        let parentElements = $(el).parents();
        hasTableBorderedClass = parentElements.hasClass("table-bordered");
      });
      
      if (!hasTableBorderedClass) {
        if ($('.dx-dropdowneditor-active .dx-texteditor-input:first').length) {

          $('.dx-dropdowneditor-active .dx-texteditor-input:first').click().trigger("blur");
        }
        if ($(".dx-popup-wrapper div[aria-label='Cancel']").length) {
          $(".dx-popup-wrapper div[aria-label='Cancel']").click();
        }

        if ($(".dx-datebox-wrapper-calendar").length || $(".dx-datebox-wrapper-time").length) {
          $('.dx-dropdowneditor-active .dx-dropdowneditor-button').click();
          let el = $('.dx-dropdowneditor-active');
          el.find(".dx-texteditor-input:first").trigger("blur");
          el.removeClass("dx-state-focused").removeClass('.dx-dropdowneditor-active');
        }
        
      }

    }
  }


}

